import { css } from 'linaria';

// FIXME: NAVI-5595 импортировать переменную из 'styles/z-indexs'
const globalOverlay = 1100;

export const tooltip = css`
  & [role='tooltip'] {
    background: var(--background-primary);
    box-shadow: var(--box-shadow-m);
    transition: unset;
    pointer-events: unset;
    padding: var(--space-100) 0;
    z-index: ${globalOverlay};

    & div::before {
      background: var(--background-primary);
    }
  }
`;
